<template>
  <v-select
    ref="controlFocoSelectEmpleado"
    label="Empleado*"
    v-model="iModel"
    :items="items"
    item-value="Id_Empleado"
    item-text="ApellidoNombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectEmpleado",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        if (valor != undefined && valor != 0) {
          var ind = this.items.findIndex(x => x.Id_Empleado == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectEmpleado", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectEmpleado", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      if (this.$AppNombre == "HomePrinting") {
        HttpHelper.get("Empleado/ListarSelect", {
          accion: "ListarInternos",
          palabra: ""
        })
          .then(response => {
            this.items = response.data;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      } else {
        HttpHelper.get("Empleado", {
          palabra: ""
        })
          .then(response => {
            this.items = response.data;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    setearFoco() {
      this.$refs.controlFocoSelectEmpleado.focus();
    }
  }
};
</script>
